import { GameStatues, IGame } from "./../../entities";
import { provider } from "../../providers";

export interface UpdateGamePayload {
  gameId: number;
  datetime: Date | null;
  location: string | null;
  notes: string | null;
  seasonId?: number | null;
  hostTeamName?: string | null;
  visitorTeamName?: string | null;
}

export const UpdateGame = async (params: UpdateGamePayload): Promise<IGame> =>
  provider.Request("/games/update", params);
